import { useParams } from "react-router-dom";
import {
    ListarFormularioEPerguntaRespostasPesquisaSatisfacaoController,
    ResponderPesquisaSatisfacaoController,
} from "../../../../../Controllers/Geral/ResponderPesquisaSatisfacao/ResponderPesquisaSatisfacaoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import UnForm from "../../../../../Components/Form";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { AgradecimentoDeResposta } from "../../ResponderFormularioLink";
import { IResponderPesquisaSatisfacao } from "../../../../../Interfaces/Geral/Formularios/FormulariosInterface";

interface URLParams {
    Token: string;
}

interface IListarPerguntasERespostasProps {
    idFormulario: number;
}

export default function ListarResponderPesquisaSatisfacao(
    props: IListarPerguntasERespostasProps
) {
    const [formAtivo, setFormAtivo] = useState(true);

    const { Token } = useParams<URLParams>();

    const TokenItens = atob(Token).split(";");
    
    const idFormulario = Number(TokenItens[1]);

    const {
        value: lstPerguntasERespostas,
        loading: lstPerguntasERespostasLoading,
    } = useAsyncEffect(() =>
        ListarFormularioEPerguntaRespostasPesquisaSatisfacaoController(
            Number(TokenItens[1]),
            TokenItens[0]
        )
    );

    const {
        loading: lstFormularioLoading,
        execute: ResponderPesquisaSatisfacao,
    } = useAsyncCallback(ResponderPesquisaSatisfacaoController);

    const handlePesquisaSatisfacaoSubmit = (
        formData: IResponderPesquisaSatisfacao
    ) => {
        setFormAtivo(true);
        ResponderPesquisaSatisfacao(Number(TokenItens[2]), TokenItens[0], {
            Recebimento: {
                DS_NOME: formData.Recebimento?.DS_NOME,
                DS_RG: formData.Recebimento?.DS_RG,
                DT_ASSINATURA: formData.Recebimento?.DT_ASSINATURA,
            },

            Respondidas: formData.Respondidas.map((resp) => ({
                DS_COMENTARIO: resp.DS_COMENTARIO,
                ID_FORMULARIO: idFormulario,
                ID_PERGUNTA: resp.ID_PERGUNTA,
                idRespostas: resp.idRespostas,
            })),
        }).then(() => setFormAtivo(false));
    };

    useEffect(() => {}, [formAtivo]);

    return (
        <>
            <OrSpinner loading={lstPerguntasERespostasLoading} spinner="capys">
                {formAtivo ? (
                    <div className="d-flex flex-column align-items-center justify-content-center p-4">
                        <div className="d-flex align-items-center justify-content-center my-10">
                            <h3>{lstPerguntasERespostas?.DS_FORMULARIO}</h3>
                        </div>

                        <UnForm handleSubmit={handlePesquisaSatisfacaoSubmit}>
                            <div className="row d-flex align-items-center justify-content-center">
                                <div className="col-md-4">
                                    <UnForm.Input
                                        name="Recebimento.DS_NOME"
                                        label="Nome"
                                        type="text"
                                    />
                                </div>
                                {/* <div className="col-md-4">
                                    <UnForm.Input
                                        name="Recebimento.DS_RG"
                                        label="RG"
                                        type="text"
                                    />
                                </div> */}

                                <div className="col-md-4">
                                    <UnForm.Input
                                        name="Recebimento.DT_ASSINATURA"
                                        label="Data Assinatura"
                                        type="date"
                                    />
                                </div>
                            </div>

                            {lstPerguntasERespostas?.ListaPesquisaSatisfacaoPerguntaRespostas?.map(
                                (perguntaPai, index) => (
                                    <div
                                        key={perguntaPai.ID_PERGUNTA}
                                        className={`h-100 mb-5 wrap ${
                                            perguntaPai.ID_PERGUNTA_PAI &&
                                            "ml-25 mb-0 mt-0 mr-25"
                                        } ${!perguntaPai.FL_ATIVO && "d-none"}`}
                                    >
                                        <>
                                            <hr className="mb-5 mt-5" />
                                            <h4>{perguntaPai.DS_PERGUNTA}</h4>
                                        </>

                                        <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                            {perguntaPai.ID_TIPO_PERGUNTA !==
                                            3 ? (
                                                <>
                                                    {perguntaPai.PesquisaSatisfacaoRespostas?.map(
                                                        (resposta) => (
                                                            <React.Fragment
                                                                key={
                                                                    resposta.ID_RESPOSTA
                                                                }
                                                            >
                                                                <li
                                                                    className="m-5"
                                                                    style={{
                                                                        height: 80,
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        justifyContent:
                                                                            "center",
                                                                        flexDirection:
                                                                            "column",
                                                                        textAlign:
                                                                            "center",
                                                                    }}
                                                                >
                                                                    <UnForm.Input
                                                                        readOnly
                                                                        name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                        value={
                                                                            perguntaPai.ID_PERGUNTA
                                                                        }
                                                                        style={{
                                                                            display:
                                                                                "none",
                                                                        }}
                                                                        wrapperClassName="d-none"
                                                                    />

                                                                    {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                    1 ? (
                                                                        <UnForm.Input
                                                                            name={`Respondidas.${index}.idRespostas.0`}
                                                                            label={
                                                                                resposta.DS_RESPOSTA
                                                                            }
                                                                            type={
                                                                                "radio"
                                                                            }
                                                                            wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                            style={{
                                                                                height: 35,
                                                                                width: 35,
                                                                            }}
                                                                            value={
                                                                                resposta.ID_RESPOSTA
                                                                            }
                                                                        />
                                                                    ) : null}

                                                                    {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                    2 ? (
                                                                        <UnForm.Input
                                                                            type="checkbox"
                                                                            color="primary"
                                                                            name={`Respondidas.${index}.idRespostas`}
                                                                            label={
                                                                                resposta.DS_RESPOSTA
                                                                            }
                                                                            value={
                                                                                resposta.ID_RESPOSTA
                                                                            }
                                                                            wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                            style={{
                                                                                height: 35,
                                                                                width: 35,
                                                                            }}
                                                                        />
                                                                    ) : null}
                                                                </li>
                                                            </React.Fragment>
                                                        )
                                                    )}
                                                </>
                                            ) : null}
                                        </ul>

                                        {!perguntaPai.ID_PERGUNTA_PAI && (
                                            <>
                                                <UnForm.Textarea
                                                    label={
                                                        perguntaPai.ID_TIPO_PERGUNTA ===
                                                        3
                                                            ? "Resposta"
                                                            : "Comentário"
                                                    }
                                                    name={`Respondidas.${index}.DS_COMENTARIO`}
                                                />
                                            </>
                                        )}

                                        {perguntaPai.PerguntasFilhas?.map(
                                            (pergunta) => (
                                                <div className="h-100 mb-5 wrap ml-25 mb-0 mt-0 mr-25 false">
                                                    <div className="mt-8">
                                                        <h4>
                                                            {
                                                                perguntaPai.DS_PERGUNTA
                                                            }
                                                        </h4>
                                                    </div>
                                                    <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                                        {pergunta.ID_TIPO_PERGUNTA !==
                                                        3 ? (
                                                            <>
                                                                {pergunta.PesquisaSatisfacaoRespostas.map(
                                                                    (
                                                                        resposta
                                                                    ) => (
                                                                        <React.Fragment
                                                                            key={
                                                                                resposta.ID_RESPOSTA
                                                                            }
                                                                        >
                                                                            <li
                                                                                className="m-5"
                                                                                style={{
                                                                                    height: 80,
                                                                                    display:
                                                                                        "flex",
                                                                                    alignItems:
                                                                                        "center",
                                                                                    justifyContent:
                                                                                        "center",
                                                                                    flexDirection:
                                                                                        "column",
                                                                                    textAlign:
                                                                                        "center",
                                                                                }}
                                                                            >
                                                                                <UnForm.Input
                                                                                    readOnly
                                                                                    name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                                    value={
                                                                                        pergunta.ID_PERGUNTA
                                                                                    }
                                                                                    style={{
                                                                                        display:
                                                                                            "none",
                                                                                    }}
                                                                                    wrapperClassName="d-none"
                                                                                />

                                                                                {pergunta.ID_TIPO_PERGUNTA ===
                                                                                1 ? (
                                                                                    <UnForm.Input
                                                                                        name={`Respondidas.${index}.idRespostas.0`}
                                                                                        label={
                                                                                            resposta.DS_RESPOSTA
                                                                                        }
                                                                                        type={
                                                                                            "radio"
                                                                                        }
                                                                                        wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                                        style={{
                                                                                            height: 35,
                                                                                            width: 35,
                                                                                        }}
                                                                                        value={
                                                                                            resposta.ID_RESPOSTA
                                                                                        }
                                                                                    />
                                                                                ) : null}

                                                                                {pergunta.ID_TIPO_PERGUNTA ===
                                                                                2 ? (
                                                                                    <UnForm.Input
                                                                                        type="checkbox"
                                                                                        color="primary"
                                                                                        name={`Respondidas.${index}.idRespostas`}
                                                                                        label={
                                                                                            resposta.DS_RESPOSTA
                                                                                        }
                                                                                        value={
                                                                                            resposta.ID_RESPOSTA
                                                                                        }
                                                                                        wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                                        style={{
                                                                                            height: 35,
                                                                                            width: 35,
                                                                                        }}
                                                                                    />
                                                                                ) : null}
                                                                            </li>
                                                                        </React.Fragment>
                                                                    )
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </ul>
                                                </div>
                                            )
                                        )}

                                        <hr />
                                    </div>
                                )
                            )}

                            <UnForm.SubmitButton
                                color="success"
                                icon={faCheck}
                                loading={lstFormularioLoading}
                                loadingSize="sm"
                                type="submit"
                                wrapperClassName="d-flex w-100 justify-content-center"
                                className="btn btn-success font-weight-bold mr-2 w-100px mb-4"
                            >
                                Enviar
                            </UnForm.SubmitButton>
                        </UnForm>
                    </div>
                ) : (
                    <AgradecimentoDeResposta />
                )}
            </OrSpinner>
        </>
    );
}
